/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_P1Inputs */

const tr_mesafeli_s20_p1 = /** @type {(inputs: Mesafeli_S20_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Sözleşme Türk Hukuku'na tabidir.`)
};

const en_mesafeli_s20_p1 = /** @type {(inputs: Mesafeli_S20_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Agreement is subject to Turkish law.`)
};

const de_mesafeli_s20_p1 = /** @type {(inputs: Mesafeli_S20_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vertrag unterliegt türkischem Recht.`)
};

const ru_mesafeli_s20_p1 = /** @type {(inputs: Mesafeli_S20_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий Договор регулируется правом Турции.`)
};

/**
* | output |
* | --- |
* | "This Agreement is subject to Turkish law." |
*
* @param {Mesafeli_S20_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_p1 = /** @type {((inputs?: Mesafeli_S20_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_p1(inputs)
	if (locale === "de") return de_mesafeli_s20_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s20_p1(inputs)
	return tr_mesafeli_s20_p1(inputs)
});